export const HeaderOptions = [
  { heading: 'Audio', path: '/listener-reviews/audio' },
  { heading: 'Video', path: '/listener-reviews/video' },
  { heading: 'Avatars', path: '/listener-reviews/profiles' },
  { heading: 'Display Name', path: '/listener-reviews/display-name' },
  { heading: 'About Me', path: '/listener-reviews/about-me' },
  { heading: 'Background Tags', path: '/listener-reviews/background-tags' },
];

export const getListenerProfileUrl = (listenerId: number, userId: number) => {
  return `/peers/listeners/profile/?listenerRoleId=${listenerId}&listenerId=${userId}`;
};
